import { render, staticRenderFns } from "./NonContrastCTBrain_v2.vue?vue&type=template&id=1a584616&"
import script from "./NonContrastCTBrain_v2.vue?vue&type=script&lang=ts&"
export * from "./NonContrastCTBrain_v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a584616')) {
      api.createRecord('1a584616', component.options)
    } else {
      api.reload('1a584616', component.options)
    }
    module.hot.accept("./NonContrastCTBrain_v2.vue?vue&type=template&id=1a584616&", function () {
      api.rerender('1a584616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/advanced/NonContrastCTBrain_v2.vue"
export default component.exports